import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-informativo-versao-modal',
    templateUrl: './informativo-versao-modal.component.html',
    styleUrls: ['./informativo-versao-modal.component.scss'],
})
export class InformativoVersaoModalComponent implements OnInit {
    constructor(
        private dialogRef: MatDialogRef<InformativoVersaoModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        //data.textoLegenda
        //data.textoSalvar
        //data.textoCancelar
    }

    cancelar() {
        this.dialogRef.close();
    }
}
